import React, { useState } from "react";
import "./Footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-router-dom";
import {
  useGetNewsletterQuery,
  useSubscribeToNewsletterMutation,
} from "../../redux/Apis/HomeSettings";
import { toast } from "react-toastify";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: newsletterData, isLoading, error } = useGetNewsletterQuery();
  const [subscribeToNewsletter] = useSubscribeToNewsletterMutation();

  const newsletter = Array.isArray(newsletterData?.data) ? newsletterData.data.find((item) => item?._id && item.active !== false) : null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    if (newsletter?._id && email.trim()) {
      setIsSubmitting(true);
      try {
        await subscribeToNewsletter({
          newsletter_id: newsletter._id,
          email: email.trim(),
        }).unwrap();

        toast.success("Tack för att du prenumererar på Dolcehem");
        setEmail("");
        setIsSubmitting(false);
      } catch (error) {
        toast.error("Något gick fel. Försök igen.");
        setIsSubmitting(false);
      }
    } else {
      toast.error("Newsletter information saknas. Försök igen senare.");
    }
  };

  return (
    <footer
      className="footer"
      style={{ background: "#FFF7C7", padding: "32px 0" }}
    >
      <div
        className="footer-padding"
        style={{ maxWidth: 1100, margin: "0 auto" }}
      >
        <div
          className="footer-wrap"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 24,
          }}
        >
          {/* Newsletter Section (Left) */}
          <div
            className="newsletter-section"
            style={{ flex: 1, minWidth: 260, maxWidth: 420 }}
          >
            <h2
              style={{
                fontWeight: 600,
                fontSize: 26,
                marginBottom: 16,
                color: "#37382f",
                letterSpacing: 0.5,
              }}
            >
              Anmälan för nyhetsbrev
            </h2>
            {newsletter && !error && <p
              style={{
                fontSize: 18,
                color: "#37382f",
                marginBottom: 20,
                lineHeight: 1.3,
                fontWeight: 300,
              }}
            >
              Prenumerera på vårt nyhetsbrev och<br />
              var först med att få tillgång till<br />
              oslagbara rabatter och exklusiva<br />
              erbjudanden!
            </p>}
            {!isLoading && newsletter && !error ? <form onSubmit={handleSubmit}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  maxWidth: 420,
                  gap: 4,
                }}
              >
                <input
                  className="custom-subscribe-input"
                  type="email"
                  placeholder="Din e-postadress"
                  aria-label="E-postadress till nyhetsbrevet"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    flex: 1,
                    fontSize: 16,
                    padding: "10px 14px",
                    border: "1.5px solid #37382f",
                    borderRadius: "0",
                    outline: "none",
                    fontFamily: "Montserrat, Arial, sans-serif",
                    minWidth: 0,
                  }}
                />
                <button
                  type="submit"
                  className="custom-subscribe-button"
                  style={{
                    fontSize: 15,
                    padding: "10px 22px",
                    border: "1.5px solid #37382f",
                    borderRadius: 0,
                    background: "#fff",
                    color: "#37382f",
                    fontWeight: 400,
                    cursor:
                      isSubmitting || !newsletter?._id
                        ? "not-allowed"
                        : "pointer",
                    height: "100%",
                    minWidth: 90,
                  }}
                  disabled={isSubmitting || !newsletter?._id}
                >
                  {isSubmitting
                    ? "Prenumererar..."
                    : "Anmäl dig"}
                </button>
              </div>
            </form> : <p role="status">{isLoading ? "Hämtar nyhetsbrev…" : "Nyhetsbrevet är inte tillgängligt just nu."}</p>}
             <div
              style={{
                fontSize: 15,
                color: "#37382f",
                marginTop: 16,
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
             Adress: Stockholm, Sweden
            </div>
             <div
              style={{
                fontSize: 13,
                color: "#37382f",
                marginTop: 16,
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              Copyright@ THAS Multitech AB<br />
              THAS Multitech, Org.nr: 559394-1957
            </div>
          </div>

          {/* Information Section (Right) */}
          <div
            className="info-section"
            style={{
              flex: 1,
              minWidth: 220,
              maxWidth: 340,
              marginLeft: "auto",
            }}
          >
            <h2
              style={{
                fontWeight: 600,
                fontSize: 26,
                marginBottom: 16,
                color: "#37382f",
                letterSpacing: 0.5,
              }}
            >
              Information
            </h2>
            <div
              style={{
                fontSize: 18,
                color: "#37382f",
                fontWeight: 300,
                lineHeight: 1.5,
                marginBottom: 20,
              }}
            >
              <div style={{ marginBottom: 6 }}>
                <Link to="/return"
                  style={{ color: "#37382f", textDecoration: "none" }}
                >
                  Frakt & returer
                </Link>
              </div>
              <div style={{ marginBottom: 6 }}>
                <Link to="/terms"
                  style={{ color: "#37382f", textDecoration: "none" }}
                >
                  Villkor
                </Link>
              </div>
              <div style={{ marginBottom: 6 }}>
                <Link to="/privacy"
                  style={{ color: "#37382f", textDecoration: "none" }}
                >
                  Sekretesspolicy
                </Link>
              </div>
              <div style={{ marginBottom: 6 }}>
                <Link to="/contact"
                  style={{ color: "#37382f", textDecoration: "none" }}
                >
                  Hjälp & Support
                </Link>
              </div>
              <div style={{ marginBottom: 6 }}>
                <Link to="/contact"
                  style={{ color: "#37382f", textDecoration: "none" }}
                >
                  Kontakta oss
                </Link>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 16,
                alignItems: "center",
                marginTop: 12,
              }}
            >
              <a
                href="https://www.instagram.com/dolcehem?igsh=dzV2dnk3YnU5bnl6"
                aria-label="Dolcehem på Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon style={{ fontSize: 32, color: "#37382f" }} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61574196843197"
                aria-label="Dolcehem på Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon style={{ fontSize: 32, color: "#37382f" }} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 700px) {
          .footer-wrap {
            flex-direction: column !important;
            gap: 32px !important;
          }
          .newsletter-section, .info-section {
            max-width: 100% !important;
            min-width: 0 !important;
          }
          .info-section {
            text-align: left !important;
            margin-left: 0 !important;
            margin-top: 32px !important;
            border-top: 1.5px solid #e0d9b6;
            padding-top: 24px;
          }
          .info-section h2 {
            margin-top: 0 !important;
          }
          .info-section div[style*='font-size'] {
            display: block !important;
            text-align: left !important;
            margin: 0 0 20px 0 !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
